/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Panel_TitleInputs */

const en_tasks_panel_title = /** @type {(inputs: Tasks_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasks`)
};

const fr_tasks_panel_title = /** @type {(inputs: Tasks_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tâches`)
};

const ms_sg2_tasks_panel_title = /** @type {(inputs: Tasks_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tugasan`)
};

/**
* | output |
* | --- |
* | "Tasks" |
*
* @param {Tasks_Panel_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_panel_title = /** @type {((inputs?: Tasks_Panel_TitleInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Panel_TitleInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_panel_title(inputs)
	if (locale === "fr") return fr_tasks_panel_title(inputs)
	return ms_sg2_tasks_panel_title(inputs)
});